import { render } from "./Payment.root.vue?vue&type=template&id=674ffaba"
import script from "./Payment.root.vue?vue&type=script&lang=js"
export * from "./Payment.root.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__